import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "text-center align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_navbar = _resolveComponent("navbar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_UniversalPopup = _resolveComponent("UniversalPopup")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_main, { class: "pa-0" }, {
        default: _withCtx(() => [
          _createVNode(_component_navbar),
          (_ctx.isMounted)
            ? (_openBlock(), _createBlock(_component_router_view, {
                key: _ctx.$route.fullPath
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_UniversalPopup, { ref: "secondDialog" }, null, 512),
          _createVNode(_component_UniversalPopup, { ref: "mainDialog" }, null, 512),
          (_ctx.globalSettings.isLoading)
            ? (_openBlock(), _createBlock(_component_v_overlay, {
                key: 1,
                "model-value": _ctx.globalSettings.isLoading,
                class: "align-center justify-center",
                persistent: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_v_progress_circular, {
                      color: "primary",
                      indeterminate: "",
                      size: "64"
                    }),
                    _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                    _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                    _createVNode(_component_v_chip, { variant: "elevated" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.globalSettings.loadingMessage), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["model-value"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}